import { Component, OnInit } from '@angular/core';
import { SurveyQuestionVm } from '../models/surveyquestionVm';
import { SurveyService } from "../services/survey.service";
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-covid-rtw-negative-test',
  templateUrl: './covid-rtw-negative-test.component.html',
  styleUrls: ['./covid-rtw-negative-test.component.css']
})
export class CovidRtwNegativeTestComponent implements OnInit {

  questions: SurveyQuestionVm[];
  constructor(private surveyServiceProxy: SurveyService,) { }

  env: string;
  async ngOnInit() {
    this.env = environment.headerBanner;
    // this.stateService.hideHeaderSideBar();
    this.questions = await this.surveyServiceProxy.rtwNegativeTestQuestions().toPromise();
    console.log(this.questions);
  }
}
